var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('side-bar-component'),_c('toasts'),_c('div',{staticClass:"core",class:{ external: _vm.$route.name === 'list' && _vm.module.is_external }},[_c('router-view')],1),_c('switch-account-menu'),_c('modal-definitions')],1)}
var staticRenderFns = []

export { render, staticRenderFns }